<template>
  <div class="ml-2">
    <v-row>
      {{ title }}
    </v-row>
    <v-row class="mt-2">
      {{ body }}
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    body: {
      type: String,
      default: "",
    },
  },
};
</script>
